module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-144x144-ea2adfd03e91261d6087c21a93346fbb.png";